module.exports = __webpack_public_path__ + "static/assets/7bf301e0e47ee990a3572e0aea2f850e.svg";